import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons'
import { Button, Modal, Space, message } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { TeamOutlined } from '@ant-design/icons'
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../../components/Common/CellText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import PopoverWatchTime from '../../../components/PopoverWatchTime'
import ReplyMessageInternal from '../../../components/ReplyMessageInternal'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_SLASH,
  HH_mm,
} from '../../../constants'
import DashboardLayout from '../../../layouts/DashboardLayout'
import utils from '../../../utils'
import InternalMessageEditTitleModal from '../InternalMessageEditTitleModal'
import InternalMessageEditReceiversModal from '../InternalMessageEditReceiversModal'
import InternalMessageEditContentModal from '../InternalMessageEditContentModal'
import InternalMessageHistoryModal from '../InternalMessageHistoryModal'
import { MessageInfo } from './InternalMessageSendDetailPageStyled'
import AccessControlAction from '../../../components/AccessControlAction'

const { confirm } = Modal

const InternalMessageDetailPage = props => {
  const {
    location,
    internalMessageStore,
    match,
    history,
    loadingAnimationStore,
    authenticationStore,
  } = props
  const { currentUser } = authenticationStore
  const [isVisibleEditModal, setIsVisibleEditModal] = React.useState(false)
  const [
    isVisibleEditReceiversModal,
    setIsVisibleEditReceiversModal,
  ] = React.useState(false)
  const [
    isVisibleEditContentModal,
    setIsVisibleEditContentModal,
  ] = React.useState(false)
  const [isVisibleHistoryModal, setIsVisibleHistoryModal] = React.useState(
    false
  )
  const { internalMessageDetail, replyInternalMessages } = internalMessageStore

  const receiverList = internalMessageDetail.receiver
    ? internalMessageDetail.receiver.map(item => ({
        id: item.code,
        full_name: item.fullname,
        assignee_type: ASSIGNEE_TYPE.USER,
        last_date_read: item.is_read ? item.updated_time : null,
      }))
    : []

  const { code } = match.params

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        await internalMessageStore.getSendMessageById(code)
      } catch (error) {
        history.push('/utility/internal-message/send')
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => internalMessageStore.clearMessageStore()
  }, [code])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tin nhắn liên thông | {systemName} Portal</title>
      </Helmet>
      <PageTitle
        location={location}
        showTitle={true}
        title={internalMessageDetail.title}>
        <Space>
          <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.download__TIN_NHAN_NOI_BO}>
            <Button
              icon={<DownloadOutlined />}
              onClick={async () => {
                try {
                  loadingAnimationStore.showSpinner(true)
                  await internalMessageStore.downloadAllZip()
                } catch (err) {
                  message.error(err.message || 'Đã có lỗi xảy ra!')
                } finally {
                  loadingAnimationStore.showSpinner(false)
                }
              }}>
              Tải tất cả đính kèm (.zip)
            </Button>
          </AccessControlAction>
          {/* <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.edit__TIN_NHAN_NOI_BO}>
            <Button
              icon={<EditOutlined />}
              type="primary"
              onClick={() => setIsVisibleEditContentModal(true)}>
              Chỉnh sửa nội dung
            </Button>
          </AccessControlAction> */}
          {/* <Button onClick={() => setIsVisibleHistoryModal(true)}>
            Lịch sử chỉnh sửa
          </Button> */}
          <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.edit__TIN_NHAN_NOI_BO}>
            <Button
              icon={<EditOutlined />}
              type="primary"
              onClick={() => setIsVisibleEditModal(true)}>
              Chỉnh sửa tiêu đề
            </Button>
          </AccessControlAction>
          <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.edit__TIN_NHAN_NOI_BO}>
            <Button
              icon={<TeamOutlined />}
              onClick={() => setIsVisibleEditReceiversModal(true)}>
              Chỉnh sửa người nhận
            </Button>
          </AccessControlAction>
          <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.delete__TIN_NHAN_NOI_BO}>
            <Button
              icon={<DeleteOutlined />}
              danger
              onClick={() => {
                confirm({
                  title: 'Bạn có chắc chắn muốn xóa tin nhắn này?',
                  icon: <ExclamationCircleOutlined />,
                  content: 'Hành động này không thể hoàn tác.',
                  okText: 'Xóa',
                  okType: 'danger',
                  cancelText: 'Hủy',
                  async onOk() {
                    try {
                      loadingAnimationStore.showSpinner(true)
                      await internalMessageStore.softDelete(code)
                      message.success('Xóa tin nhắn thành công!')
                      history.push('/utility/internal-message/send')
                    } catch (err) {
                      message.error(err?.vi || 'Đã có lỗi xảy ra!')
                    } finally {
                      loadingAnimationStore.showSpinner(false)
                    }
                  },
                })
              }}>
              Xóa
            </Button>
          </AccessControlAction>
          {/* {internalMessageDetail.owner === currentUser?.username && (
            <>
            </>
          )} */}
        </Space>
      </PageTitle>
      <ContentBlockWrapper>
        <TitleContentBox>Thông tin</TitleContentBox>
        <MessageInfo>
          <dt>Người nhận</dt>
          <dd>
            <div className={'assign'}>
              {receiverList.length > 0 ? (
                <PopoverWatchTime
                  showFullTag={true}
                  userList={receiverList}
                  title={'Danh sách người nhận'}
                />
              ) : (
                <EmptyText>Không rõ.</EmptyText>
              )}
            </div>
          </dd>
          <dt>Ngày gửi</dt>
          <dd>
            {internalMessageDetail.created_time ? (
              `${moment(internalMessageDetail.created_time).format(
                DATE_FORMAT_SLASH
              )} - ${moment(internalMessageDetail.created_time).format(HH_mm)}`
            ) : (
              <EmptyText>Không rõ.</EmptyText>
            )}
          </dd>
          <dt>Nội dung</dt>
          <dd>
            {internalMessageDetail.content ? (
              WordBreak(internalMessageDetail.content, true)
            ) : (
              <EmptyText>Không rõ.</EmptyText>
            )}
          </dd>
          <dt>Tài liệu đính kèm</dt>
          <dd>
            {internalMessageDetail.file_ids?.length > 0 ? (
              <>
                {internalMessageDetail.file_ids.map(file => (
                  <FileItem
                    key={file.file_id}
                    file_id={file.file_id}
                    file_name={file.name}
                    file_type={utils.getExtensionFile(file.name)}
                  />
                ))}
              </>
            ) : (
              <EmptyText>Không có.</EmptyText>
            )}
          </dd>
        </MessageInfo>
      </ContentBlockWrapper>
      <InternalMessageEditTitleModal
        isVisible={isVisibleEditModal}
        handleCancel={() => setIsVisibleEditModal(false)}
        code={code}
        initialTitle={internalMessageDetail.title}
      />
      <InternalMessageEditContentModal
        isVisible={isVisibleEditContentModal}
        handleCancel={() => setIsVisibleEditContentModal(false)}
        code={internalMessageDetail.code}
        initialContent={internalMessageDetail.content}
      />
      <InternalMessageEditReceiversModal
        isVisible={isVisibleEditReceiversModal}
        handleCancel={() => setIsVisibleEditReceiversModal(false)}
        code={code}
        receivers={internalMessageDetail.receiver}
      />
      <ReplyMessageInternal
        replyInternalMessages={replyInternalMessages}
        code={code}
        internalMessageDetail={internalMessageDetail}
        isReceive={false}
      />
      <InternalMessageHistoryModal
        code={internalMessageDetail.code}
        isVisible={isVisibleHistoryModal}
        handleCloseHistory={() => setIsVisibleHistoryModal(false)}
      />
    </DashboardLayout>
  )
}

InternalMessageDetailPage.propTypes = {}

export default inject(
  'internalMessageStore',
  'selectUserStore',
  'loadingAnimationStore',
  'authenticationStore'
)(observer(InternalMessageDetailPage))
